var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-full"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFullscreen),expression:"!isFullscreen"}],on:{"click":_vm.handleFullScreen}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFullscreen),expression:"isFullscreen"}],on:{"click":_vm.handleFullScreen}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509a5787","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/screenfull.vue
// module id = null
// module chunks = 